import { useState, useEffect, useRef } from "react";
import  { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";

import React from "react";

import { useInView } from 'react-intersection-observer';
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import fadeInElement from "components/WebDesigner/Utilities/ElementAnimator";
//since states ref and use effect can't be used in a wbcomponents rener function some may need to have if moved to a seperate react function
export default function RenderSection({component,children,screenSize,atts,isEditor,userContext}:WBRenderProps&{atts:any}){



    const hideRendering =  (window as any).optimizevrendering == true;


    
    // const [savedHeight,setSavedHeight] = useState(0);

    const heightRef = useRef<number>(400);
    const [viewState,updateView] = useState(true);
    const [refDom,setRefDom] = useState<HTMLDivElement|null>(null);

    const { ref, inView } = useInView({
      /* Optional options */
      threshold: 0,
      initialInView:false,
      rootMargin: "500px",
     
 
      onChange: (inView, entry) => {  

        if(inView && !viewState){
       
          updateView(true);
         
      
        }
        else if(!inView && viewState){
          heightRef.current= refDom?.clientHeight??0;
          updateView(false);

   
        }
      }

    });


    const updateHeight = ()=>{
      
      if(refDom){

        heightRef.current = refDom.clientHeight;
       
       }

    }

    const setRef=(elem:any)=>{
      setRefDom(elem);
      ref(elem)

    }

    let sectionType = component.componentAttributes['sectionType']??"condensed";
   
    const isCondensed = (sectionType === "condensed");

    let pageWidthString = "var(--half-width)";
    useEffect(() => {

      if(viewState && refDom){
        updateHeight();
        if(hideRendering)
        fadeInElement(refDom)


      }
     // eslint-disable-next-line
    },[viewState,screenSize])

    useEffect(() => {

      if(hideRendering){
      if(component.inView!=inView){

      
        component.inView = inView;

        let canv = ((window as any).canvasRef);
        if(canv){
          canv.forceUpdate();
        }

        updateView(inView);
      }
    }
// eslint-disable-next-line
    },[inView])

 
    const width = `calc(50% - ${pageWidthString})`;
 
    const tag = getNodeComponentAttributeValue(component,"tag","");

    const tagInfo = tag.length>0?{sectiontag:tag}:{};
    

    if(hideRendering && !inView){
      atts = {...atts};
      atts.style = {...atts.style,padding:"0"}
    }

    return (

 
  

        <div {...atts}  {...tagInfo}  ref={ (elm:any)=>{setRef(elm);}}>
        
        {(component.inView||!hideRendering||!isEditor)?

        
             <>
            {isCondensed&&<div className="section-buffer" style= {{width:width}}></div>}
        
            {children}
      
            {isCondensed&&<div className="section-buffer"  style= {{width:width}}></div>}
            </>
        :<div style={{height:heightRef.current+"px"}}></div>
}
    
        </div>
    )

}










